import {
  MediumContainer,
  NextBtn,
} from "../../../screens/User/Users/components/IncidentType/incident.style";
import { AiOutlineClose } from "react-icons/ai";

const EMRReminderModal = ({
  setShowEMRReminder,
  onAcknowledge,
}: {
  setShowEMRReminder: (value: boolean) => void;
  onAcknowledge: () => void;
}) => {
  function handleModalClose() {
    setShowEMRReminder(false);
    onAcknowledge();
  }

  return (
    <MediumContainer>
      <div className="flex">
        <button
          className="cursor-pointer border-0 bg-transparent"
          onClick={handleModalClose}
          style={{ fontSize: "30px" }}
        >
          <AiOutlineClose size={25} />
        </button>
      </div>
      <p className="text-md px-5 py-5 text-center font-semibold">
        <strong>Reminder:</strong> Complete required assessments, care-plan updates, and notifications in the EMR per facility protocol.
      </p>

      <div className="mb-14 mr-7 mt-5">
        <NextBtn onClick={handleModalClose}>I Understand</NextBtn>
      </div>
    </MediumContainer>
  );
};

export default EMRReminderModal;
